import { showUserAlert } from "../../utils/userErrorMessage";
import React, { useEffect, useState } from "react";
import Header from "../../Component/Header";
import AllUnpaidDetail from "./AllUnpaidDetail";
import GeneralUnpaidDetail from "./GeneralUnpaidDetail";
import SchoolUnpaidDetail from "./SchoolUnpaidDetail";
import CommuteUnpaidDetail from "./CommuteUnpaidDetail";
import TourUnpaidDetail from "./TourUnpaidDetail";
import { CLOSING_DAY_LAST } from "./closingDateUtils";
import { supabase } from "../../supabase/client";
import { userErrorMessage } from "../../utils/userErrorMessage";

export default function UnpaidDetail() {
  const [type, setType] = useState("all");
  const [closingDay, setClosingDay] = useState(CLOSING_DAY_LAST);
  const [closingDayReady, setClosingDayReady] = useState(false);

  useEffect(() => {
    const loadClosingDay = async () => {
      const company = localStorage.getItem("email") || "";
      if (!company) {
        setClosingDayReady(true);
        return;
      }

      try {
        const { data, error } = await supabase
          .from("company_settings")
          .select("revenue_closing_day")
          .eq("company", company)
          .maybeSingle();

        if (error) {
          console.error("마감 날짜 설정 조회 실패:", error);
          setClosingDayReady(true);
          return;
        }

        if (data?.revenue_closing_day) {
          setClosingDay(data.revenue_closing_day);
        }
      } catch (error) {
        console.error("마감 날짜 설정 조회 실패:", error);
        setClosingDayReady(true);
        return;
      }

      setClosingDayReady(true);
    };

    loadClosingDay();
  }, []);

  const handleClosingDayChange = async (nextClosingDay) => {
    const previousClosingDay = closingDay;
    setClosingDay(nextClosingDay);

    const company = localStorage.getItem("email") || "";
    if (!company) return;

    let error = null;
    try {
      const response = await supabase.from("company_settings").upsert(
        {
          company,
          company_name: localStorage.getItem("companyName") || company,
          revenue_closing_day: nextClosingDay,
          updated_at: new Date().toISOString(),
        },
        { onConflict: "company" }
      );
      error = response.error;
    } catch (caughtError) {
      error = caughtError;
    }

    if (error) {
      setClosingDay(previousClosingDay);
      console.error("마감 날짜 저장 실패:", error);
      showUserAlert("마감 날짜 저장 실패: " + userErrorMessage(error));
    }
  };

  const renderDetail = () => {
    switch (type) {
      case "general":
        return <GeneralUnpaidDetail closingDay={closingDay} setClosingDay={handleClosingDayChange} />;
      case "school":
        return <SchoolUnpaidDetail closingDay={closingDay} setClosingDay={handleClosingDayChange} />;
      case "commute":
        return <CommuteUnpaidDetail closingDay={closingDay} setClosingDay={handleClosingDayChange} />;
      case "tour":
        return <TourUnpaidDetail closingDay={closingDay} setClosingDay={handleClosingDayChange} />;
      default:
        return <AllUnpaidDetail closingDay={closingDay} setClosingDay={handleClosingDayChange} />;
    }
  };

  return (
    <div className="space-y-1">
      <Header />
      <div className="px-4 py-1">
      <h2 className="text-lg font-semibold">매출 내역</h2>
      <div className="flex flex-wrap items-center gap-4">
        <label className="font-semibold">구분</label>
        <div className="flex gap-2">
          {["전체", "일반", "학단", "통근", "투어"].map((label) => {
            const value = {
              전체: "all",
              일반: "general",
              학단: "school",
              통근: "commute",
              투어: "tour",
            }[label];

            return (
              <button
                key={value}
                type="button"
                onClick={() => setType(value)}
                className={`px-4 py-1 rounded-full border transition ${
                  type === value ? "bg-blue-600 text-white" : "bg-gray-100 text-gray-700 hover:bg-gray-200"
                }`}
              >
                {label}
              </button>
            );
          })}
        </div>
      </div>

      <div className="mt-1">
        {closingDayReady ? renderDetail() : <div className="py-6 text-center text-sm text-gray-500">마감 날짜 설정을 불러오는 중입니다.</div>}
      </div>
    </div>
    </div>
  );
}
